import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-overlay',
  templateUrl: './spinner-overlay.component.html',
  styleUrls: ['./spinner-overlay.component.css']
})
export class SpinnerOverlayComponent implements OnInit {
    @Input() public message: string = "OverlayComponent";
    @Input() public successErrorMessgae: string = "";
  constructor() {}

  public ngOnInit() {}
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/spinner-overlay/spinner-overlay.component.ts